import { httpFetchUsers } from "api/support/user";
import Container from "components/layout/Container";
import Main from "components/layout/Main";
import SupportSidebar from "components/layout/SupportSidebar";
import { Select } from "components/misc";
import Pagination from "components/ui/Pagination";
import Search from "components/ui/Search";
import Table from "components/ui/Table";
import TransactionItem from "components/ui/TransactionItem";
import { DateTime } from "luxon";
import { useState } from "react";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import { supportRoutes } from "routes/routes";

const Users: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState("A-Z");
  const limit = 50;

  const {
    data: { users, total, page },
  } = useQuery(
    ["users", currentPage, order],
    () => httpFetchUsers(limit, currentPage, order),
    {
      initialData: {
        users: [],
        total: 0,
        page: 1,
      },
    }
  );

  const toggleOpen = (u: any) => {
    if (isOpen && u.email === user?.email) return setIsOpen(false);

    setUser(u);
    return setIsOpen(true);
  };

  const changeSort = (e: any) => {
    setOrder(e?.target?.value);
  };

  return (
    <Container>
      <SupportSidebar />
      <Main className="mx-5 mt-5 text-left">
        <div className="flex items-center justify-between w-full">
          <h3 className="text-2xl">Users</h3>
          <div className="w-3/6">
            <Search type="user" />
          </div>
        </div>

        <p className="mt-5 mb-1 text-lg font-bold">Sort</p>
        <Select
          onChange={changeSort}
          value={order}
          data={["A-Z", "Z-A", "Newest to Oldest", "Oldest to Newest"]}
          className="w-full md:w-7/12"
        />

        <div className="flex gap-8 mt-14">
          <div className="w-7/12">
            <Table
              header={["Username", "", ""]}
              data={[
                ...users?.map((user: any) => [
                  user.userName,
                  "",
                  "",
                  () => toggleOpen(user),
                ]),
              ]}
            />

            <Pagination
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              limit={limit}
              page={page}
              total={total}
            />
          </div>
          {isOpen && (
            <div className="w-5/12 px-8 py-10 rounded-lg bg-orange-50">
              <h4 className="mb-5">@{user?.userName}</h4>

              <TransactionItem title="Username" value={`@${user?.userName}`} />
              <TransactionItem
                title="Registered full Name"
                value={`${user?.firstName} ${user?.lastName}`}
              />
              {/* <TransactionItem title="e-mail" value={user?.email} />
              <TransactionItem title="Phone Number" value={user?.phoneNumber} /> */}
              <TransactionItem
                title="Verification Level"
                value={`Level ${user?.level}`}
              />
              <TransactionItem
                title="Date registered"
                value={DateTime.fromISO(user?.regDate).toFormat("D")}
              />

              <div className="flex flex-wrap mt-10 gap-x-20 gap-y-10">
                <Link to={`${supportRoutes.balances}/user/${user.id}`}>
                  <span
                    className={`px-5 py-1.5 bg-black text-white rounded-full mr-3 cursor-pointer`}
                  >
                    Balances
                  </span>
                </Link>
                <Link to={`${supportRoutes.transactions}/user/${user.id}`}>
                  <span
                    className={`px-5 py-1.5 bg-black text-white rounded-full mr-3 cursor-pointer`}
                  >
                    Transactions
                  </span>
                </Link>
                <Link to={`${supportRoutes.analytics}/user/${user.id}`}>
                  <span
                    className={`px-5 py-1.5 bg-black text-white rounded-full mr-3 cursor-pointer`}
                  >
                    Analytics
                  </span>
                </Link>
                <Link to={`${supportRoutes.explorer}/user/${user.id}`}>
                  <span
                    className={`px-5 py-1.5 bg-black text-white rounded-full mr-3 cursor-pointer`}
                  >
                    Addresses Explorer
                  </span>
                </Link>
              </div>
            </div>
          )}
        </div>
      </Main>
    </Container>
  );
};
export default Users;
